/**
 * 把 i18next 的 language code 對應到 API 認得的 locale enum。
 *
 * - i18next: 'en' | 'zh-TW' | 'es-MX' | 'fr-CA'
 * - API:     'en-US' | 'zh-TW' | 'es-MX' | 'fr-CA'
 */

import type { Locale } from './api';

export function toApiLocale(lng?: string): Locale {
  switch (lng) {
    case 'zh-TW':
      return 'zh-TW';
    case 'es-MX':
      return 'es-MX';
    case 'fr-CA':
      return 'fr-CA';
    case 'en':
    case 'en-US':
    default:
      return 'en-US';
  }
}
